/*
=========================================================
SHARE3DCAM 自定义模块
模块名称：SHARE Tabs
文件位置：assets/share-tabs.js
版本号：v2.0.0
本次修改：
1. 顶部大 Tabs 改为读取各 block 自己输出的 metadata
2. 不再依赖 section 层读取 theme block settings
3. 保留 Multi 子项自动组装与切换
=========================================================
*/

(function () {
  function toNumber(value, fallback) {
    var num = parseInt(value, 10);
    return isNaN(num) ? fallback : num;
  }

  function toTwoDigits(number) {
    var num = toNumber(number, 0);
    return num < 10 ? '0' + num : String(num);
  }

  function syncTriggerActiveState(list, key) {
    list.forEach(function (item) {
      item.classList.toggle('is-active', item.getAttribute('data-key') === key);
    });
  }

  function buildTopLevelTabs(root) {
    var navWrap = root.querySelector('[data-share-tabs-nav-wrap]');
    var nav = root.querySelector('[data-share-tabs-nav]');
    var panels = Array.prototype.slice.call(
      root.querySelectorAll('[data-share-tabs-panel]')
    );

    if (!navWrap || !nav || !panels.length) return;

    var items = panels.map(function (panel) {
      var meta = panel.querySelector('[data-share-tabs-top-meta]');
      if (!meta) return null;

      return {
        panel: panel,
        key: meta.getAttribute('data-key') || '',
        label: meta.getAttribute('data-label') || '',
        show: meta.getAttribute('data-show') === 'true'
      };
    }).filter(function (item) {
      return item && item.show && item.label;
    });

    nav.innerHTML = '';

    if (!items.length) {
      navWrap.hidden = true;
      return;
    }

    items.forEach(function (item) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'share-tabs__nav-btn';
      button.setAttribute('data-share-tabs-trigger', '');
      button.setAttribute('data-key', item.key);
      button.setAttribute('role', 'tab');
      button.setAttribute('aria-selected', 'false');
      button.textContent = item.label;
      nav.appendChild(button);
    });

    navWrap.hidden = false;

    var triggers = Array.prototype.slice.call(
      root.querySelectorAll('[data-share-tabs-trigger]')
    );

    function activateTopTab(key) {
      triggers.forEach(function (trigger) {
        var isActive = trigger.getAttribute('data-key') === key;
        trigger.classList.toggle('is-active', isActive);
        trigger.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        if (panel.getAttribute('data-key') === key) {
          panel.classList.add('is-active');
        } else {
          panel.classList.remove('is-active');
        }
      });
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        activateTopTab(trigger.getAttribute('data-key'));
      });
    });

    var defaultIndex = toNumber(root.getAttribute('data-default-tab-index'), 1);
    if (defaultIndex < 1) defaultIndex = 1;
    if (defaultIndex > items.length) defaultIndex = 1;

    activateTopTab(items[defaultIndex - 1].key);
  }

  function collectSubitems(multiRoot) {
    var sourceItems = Array.prototype.slice.call(
      multiRoot.querySelectorAll('[data-share-tabs-subitem]')
    );

    return sourceItems.map(function (item, index) {
      var show = item.getAttribute('data-show') === 'true';
      var title = item.getAttribute('data-title') || '';
      var desc = item.getAttribute('data-desc') || '';
      var video = item.getAttribute('data-video') || '';
      var mobileLabel = item.getAttribute('data-mobile-label') || '';

      return {
        key: item.getAttribute('data-key') || ('subitem-' + index),
        show: show,
        title: title,
        desc: desc,
        video: video,
        mobileLabel: mobileLabel,
        indexLabel: toTwoDigits(index + 1)
      };
    }).filter(function (item) {
      return item.show && item.title && item.video;
    });
  }

  function createDesktopCard(subitem) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'share-tabs__multi-card';
    button.setAttribute('data-share-tabs-sub-trigger', '');
    button.setAttribute('data-key', subitem.key);
    button.setAttribute('data-title', subitem.title);
    button.setAttribute('data-desc', subitem.desc);
    button.setAttribute('data-video', subitem.video);
    button.setAttribute('data-mobile-label', subitem.mobileLabel);

    button.innerHTML =
      '<span class="share-tabs__multi-card-index">' + subitem.indexLabel + '</span>' +
      '<span class="share-tabs__multi-card-body">' +
        '<span class="share-tabs__multi-card-title">' + subitem.title + '</span>' +
        '<span class="share-tabs__multi-card-desc">' + subitem.desc + '</span>' +
      '</span>';

    return button;
  }

  function createMobileButton(subitem) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'share-tabs__multi-mobile-btn';
    button.setAttribute('data-share-tabs-sub-trigger', '');
    button.setAttribute('data-key', subitem.key);
    button.setAttribute('data-title', subitem.title);
    button.setAttribute('data-desc', subitem.desc);
    button.setAttribute('data-video', subitem.video);
    button.setAttribute('data-mobile-label', subitem.mobileLabel);
    button.textContent = subitem.mobileLabel || subitem.indexLabel;
    return button;
  }

  function initMultiTab(multiRoot) {
    if (!multiRoot || multiRoot.dataset.initialized === 'true') return;
    multiRoot.dataset.initialized = 'true';

    var desktopNav = multiRoot.querySelector('[data-share-tabs-sub-nav-desktop]');
    var mobileScroll = multiRoot.querySelector('.share-tabs__multi-mobile-scroll');
    var currentTitle = multiRoot.querySelector('[data-share-tabs-current-title]');
    var currentDesc = multiRoot.querySelector('[data-share-tabs-current-desc]');
    var video = multiRoot.querySelector('video[data-share-tabs-video]');
    var source = video ? video.querySelector('source') : null;

    if (!desktopNav || !mobileScroll || !video || !source) return;

    var subitems = collectSubitems(multiRoot);
    if (!subitems.length) return;

    desktopNav.innerHTML = '';
    mobileScroll.innerHTML = '';

    subitems.forEach(function (subitem) {
      desktopNav.appendChild(createDesktopCard(subitem));
      mobileScroll.appendChild(createMobileButton(subitem));
    });

    var allTriggers = Array.prototype.slice.call(
      multiRoot.querySelectorAll('[data-share-tabs-sub-trigger]')
    );

    var switchTimer = null;

    function setSwitchingState(isSwitching) {
      multiRoot.classList.toggle('is-switching', !!isSwitching);
    }

    function activateSubItemByTrigger(trigger) {
      var key = trigger.getAttribute('data-key');
      var nextTitle = trigger.getAttribute('data-title') || '';
      var nextDesc = trigger.getAttribute('data-desc') || '';
      var nextVideo = trigger.getAttribute('data-video') || '';

      if (!key) return;

      syncTriggerActiveState(allTriggers, key);
      setSwitchingState(true);

      if (switchTimer) clearTimeout(switchTimer);

      switchTimer = setTimeout(function () {
        if (currentTitle) currentTitle.textContent = nextTitle;
        if (currentDesc) currentDesc.textContent = nextDesc;

        if (nextVideo) {
          source.src = nextVideo;
          video.load();
        } else {
          setSwitchingState(false);
        }
      }, 120);

      var handleLoaded = function () {
        setSwitchingState(false);
        video.removeEventListener('loadeddata', handleLoaded);
        video.removeEventListener('canplay', handleLoaded);
      };

      video.addEventListener('loadeddata', handleLoaded);
      video.addEventListener('canplay', handleLoaded);

      if (window.innerWidth <= 768) {
        trigger.scrollIntoView({
          behavior: 'smooth',
          inline: 'center',
          block: 'nearest'
        });
      }
    }

    allTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        activateSubItemByTrigger(trigger);
      });
    });

    var defaultIndex = toNumber(
      multiRoot.getAttribute('data-default-subitem-index'),
      1
    );

    if (defaultIndex < 1) defaultIndex = 1;
    if (defaultIndex > subitems.length) defaultIndex = 1;

    var defaultKey = subitems[defaultIndex - 1].key;

    var defaultTrigger = allTriggers.find(function (item) {
      return item.getAttribute('data-key') === defaultKey;
    });

    if (!defaultTrigger) defaultTrigger = allTriggers[0];
    if (defaultTrigger) activateSubItemByTrigger(defaultTrigger);
  }

  function initShareTabs() {
    var roots = Array.prototype.slice.call(
      document.querySelectorAll('[data-share-tabs]')
    );

    if (!roots.length) return;

    roots.forEach(function (root) {
      buildTopLevelTabs(root);

      var multiTabs = Array.prototype.slice.call(
        root.querySelectorAll('[data-share-tabs-multi]')
      );

      multiTabs.forEach(function (multiRoot) {
        initMultiTab(multiRoot);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShareTabs);
  } else {
    initShareTabs();
  }
})();